// lib/anmeldungSpeichern.js — Admin-/Vereinsanmeldung im Browser ablegen
//
// Aus LoginModal.jsx herausgezogen (02.10.2026, Aufgabe 132), damit das
// gemeinsame Anmeldefenster (pages/AnmeldenPage.jsx) genau denselben Weg nimmt:
// gleiche Schlüssel im localStorage, gleiche Form der Daten.

/** @returns {object} userData wie bisher an onLogin übergeben */
export function vereinsAnmeldungSpeichern(data, emailEingabe) {
  const userData = {
    success: true,
    token: data.token,
    refreshToken: data.refreshToken || null,
    user: {
      vereins_id: data.user?.vereins_id || data.id,
      name: data.user?.name || data.name,
      email: data.user?.email || emailEingabe,
      benutzername: data.user?.benutzername || data.benutzername,
      role: data.user?.role || 'verein',
      ort: data.user?.ort || data.ort,
      ansprechpartner: data.user?.ansprechpartner || data.ansprechpartner,
      verband_id_tenant: data.user?.verband_id_tenant ?? null
    }
  };
  localStorage.setItem('token', data.token);
  if (userData.user.role === 'admin') {
    localStorage.setItem('adminData', JSON.stringify(userData));
    localStorage.removeItem('clubData');
    localStorage.removeItem('clubId');
  } else {
    localStorage.setItem('clubData', JSON.stringify(userData));
    localStorage.setItem('clubId', String(userData.user.vereins_id));
    localStorage.removeItem('adminData');
  }
  return userData;
}

/**
 * Turniertag-Konto ablegen und Ziel liefern — wie die alten Anmeldeseiten
 * (EinwaageLoginPage, RegStaffLoginPage, StaffLoginPage, JudgeApp).
 * Der Kampfrichter merkt sich die Anmeldung nur für diesen Tab (JudgeApp liest
 * sessionStorage 'kr_anmeldung' und fragt dann nur noch die Rolle).
 */
export function personalAnmeldungSpeichern(t) {
  if (t.art === 'kampfrichter') {
    sessionStorage.setItem('kr_anmeldung', JSON.stringify({ token: t.token, kampfrichter: t.daten.kampfrichter }));
    return '/judge';
  }
  localStorage.setItem('token', t.token);
  if (t.art !== 'personal') localStorage.removeItem('personalToken');
  if (t.art === 'personal') {
    localStorage.setItem('staffData', JSON.stringify({ name: t.daten.name, rolle: t.daten.rolle }));
    // Bleibt liegen, wenn Waage/Check-in ihren Einsatz-Zugang unter 'token' ablegen (lib/personalEinsatz.js)
    localStorage.setItem('personalToken', t.token);
    return '/staff';
  }
  if (t.art === 'registrierung') return '/reg';
  return '/einwaage-staff';
}
